import { ReportImg } from "@/components/report/commons/ReportImg";
import { Typography } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface BathDialogProps extends HelpDialogLayoutProps {}
export default function BathDialog(props: BathDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠への影響</Typography>
          <BodyTypographies
            contents={[
              "人間の深部体温（脳や内臓の温度）は24時間周期で変動しており、日中は上昇し、夜間の睡眠時には低下します。眠気は、この寝る前の深部体温が下がるタイミングで生じて、寝付きを促します。",
              "就寝前の入浴には、一度深部体温を上げる効果があります。この結果、深部体温が下がりやすくなるため、寝付きの改善が期待できます。ただし、寝る直前に熱いお湯へ入浴すると深部体温が上がり過ぎて逆効果となり、寝付きづらくなる可能性があるので注意が必要です。",
              <ReportImg
                image_name="image_report_bath.png"
                style={{ width: "100%", paddingTop: "24px" }}
              />,
            ]}
          />
        </SectionStack>
        <SectionStack>
          <Typography variant="subtitle2">おすすめの入浴方法</Typography>
          <BodyTypographies
            contents={[
              "入浴のタイミングとお湯の温度は以下を参考にしてください。入浴による体温調整とリラックス効果を活用して、良い眠りに繋げましょう。",
              "",
              "ぬるめのお風呂の場合",
              "温度：38～41度（深部体温を少し上げ、下がりやすくする）",
              "タイミング：寝る1～2時間前にゆっくりつかる",
              "",
              "熱いお風呂の場合",
              "温度：41度以上 （深部体温が大幅に上がるため、下がるまでに時間がかかる）",
              "タイミング：寝る3時間前までに入る",
              "",
              "お湯につかる時間が取れない時、シャワーのみでも工夫次第で寝付きの改善が期待されます。例えば、足湯（洗面器にお湯をはって足だけ入れる）や首の後ろなどの太い血管が通る部分をシャワーで温めるなどです。ぜひ試してみてください。",
            ]}
          />
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
